import styled, { css } from 'styled-components'
import { up } from 'styled-breakpoints'

interface BoxesGridProps {
  layout?: 'simple' | 'fill-gray' | 'simple-separator'
}

const columns5 = css`
  ${up('sm')} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${up('lg')} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${up('xl')} {
    grid-template-columns: repeat(5, 1fr);
  }
`

const layout = {
  simple: css`
    grid-gap: 6.4rem;

    ${up('sm')} {
      grid-template-columns: repeat(2, 1fr);
    }

    ${up('lg')} {
      grid-template-columns: repeat(4, 1fr);
    }

    .title {
      margin: 5.6rem 0 0.8rem;
    }
  `,
  'fill-gray': css`
    grid-gap: 0.8rem;
    ${columns5}

    .title {
      margin: 6.4rem 0 0;

      ${up('sm')} {
        margin: 10rem 0 0;
      }
    }

    .container {
      background: #f4f6f6;
      border-radius: 0.4rem;
      padding: 5rem 4.5rem 4rem;
    }
  `,
  'simple-separator': css`
    ${columns5}
    position: relative;
    grid-gap: 2.4rem 0;

    ${up('sm')} {
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 1px;
        height: 100%;
        background: white;
      }
    }

    .title {
      margin: 6.4rem 0 0;
    }

    .container {
      padding: 4.8rem 3.2rem;
      border-bottom: 1px solid var(--gray-3);

      &:last-child {
        border-bottom: 0;
      }

      ${up('sm')} {
        padding: 6.4rem 4.8rem;

        border-bottom: 0;
        border-right: 1px solid var(--gray-3);
      }
    }
  `,
}

const Grid = styled.div<BoxesGridProps>`
  display: grid;
  ${(props) => layout[props.layout || 'simple']}
`

export default Grid
